var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-full-screen-container',{staticClass:"bg"},[_c('div',{staticClass:"header"}),_c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"item1"}),_c('div',{staticClass:"item2",on:{"click":function($event){return _vm.go('/dataScreenView2')}}}),_c('div',{staticClass:"item3"}),_c('div',{staticClass:"item4"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }